/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css";
import "./assets/css/media.css";
import { HOME_URL, RESET_PASSWORD, MY_ACCOUNT, RESPONSIBLE_GAME_PLAY, USER_DATA_DETECTION, ALL_SESSION_LOGOUT_API_URL, GET_PROFILE_API_URL,PRIVACY_POLICY, TERMS_CONDITIONS, PROMOTIONAL_RULES, CONTACT, PROFILE_UPDATE_API_URL } from './components/Shared/constant';
import Header from "./components/Shared/Header";
import Home from './components/Home';
import Footer from './components/Shared/Footer';
import Account from "./components/Account";
import ResetPassword from './components/ResetPassword';
import Contact from "./components/Contact";
import SignUpSidebar from './components/Shared/SignUp';
import LoginSignupModal from './components/LoginSignupModal';
import Privacy from './components/Privacy';
import Userdatadeletion from './components/Userdatadeletion';
import TermsConditions from './components/TermsConditions';
import PromotionalRules from './components/PromotionalRules';
import ScrollToTop from './components/ScrollToTop';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { getAccessToken, checkLogin, CallLogoutUser, ClearReduxFlow, updateUser } from './redux/actions';
import ResponsiveSidebar from './components/Shared/ResponsiveSidebar';
import ResponsibleGamePlay from './components/ResponsibleGamePlay';
import LocationRedirect from './LocationRedirect';
import LocateCheck from './components/LocateCheck';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function App() {
  const [ SignUp, setSignUp ] = useState(false);
  const [ LoginSigupUp, setLoginSigupUp ] = useState(false);
  const [ LocationGet, setLocationGet ] = useState("");
  const [ fromBankendSignupDetails, setFromBankendSignupDetails ] = useState({});
  const dispatch = useDispatch();
  const { accessToken, is_login, profiledata, spoofingDetection,checkCacheNews, isSiteBlock } = useSelector((state) => state.allReducers);
  const [ VerifiedLoginEmail, setVerifiedLoginEmail ] = useState("");
  // const LocationUrl = window.location.href.split("/")[3];
  const [ AllclearData, setAllclearData ] = useState(false);

  // ✅ safer URL parsing
  const [LocationUrl, setLocationUrl] = useState(
    window.location.pathname.replace("/", "")
  );

  const alreadyCheckedSuccess = sessionStorage.getItem("LocateCheckPassed");
  
  useEffect(() => {
    setLocationUrl(window.location.pathname.replace("/", ""));
  }, [window.location.pathname]);

  useEffect(() => {
    if(alreadyCheckedSuccess === "true") {
        if(LocationUrl === "?action=login" && accessToken === "" && is_login === "no") {
          setLoginSigupUp(true);
        };

        if(LocationUrl?.includes("?action&code=") === true) {
          setLoginSigupUp(true);
        };

        if(accessToken !== "") {
          window.axios.get(ALL_SESSION_LOGOUT_API_URL, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + accessToken
            }}).then(function (result) {
                if(result?.status === 200) {
                  
                };
            }).catch(function (result) {
                if(result?.response?.status === 403) {
                    toast.error("The session expired due to logging in on another device.");
                    localStorage.removeItem("access_tokens");
                    dispatch(CallLogoutUser());
                };
            });
        }
    };
  }, [ LocationUrl, accessToken, is_login, alreadyCheckedSuccess ]);

  useEffect(() => {
    if(checkCacheNews === undefined || checkCacheNews === null) {
      dispatch(ClearReduxFlow());
    };
  }, [checkCacheNews]);
  
  useEffect(()=>{
    if(spoofingDetection === null || spoofingDetection === "" || spoofingDetection === undefined){
        document.getElementById("spoofingDetectionModel").style.display = "none";
    }else{
        document.getElementById("spoofingDetectionModel").style.display = "flex";
    };
  },[spoofingDetection]);

  useEffect(() => {
    if(isSiteBlock !== false && isSiteBlock !== null) {
        if(accessToken !== "" && accessToken !== null){
          window.axios.get(GET_PROFILE_API_URL, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + accessToken
            }}).then(function (result) {
                  if(result?.status === 200) {
                  dispatch(getUser(result?.data?.data));
                  checkUpdateProfile(result?.data?.data)
                };
            }).catch(function (result) {
                if(result?.response?.status === 403) {
                    dispatch(CallLogoutUser());
                    localStorage.removeItem("access_tokens");
                }
            });
        }
    }
  },[]);

  const checkUpdateProfile = (data) =>{
    if(data?.is_email_check == false && data?.billing_address1 && data?.billing_address2){
     const jsonData = JSON.stringify({ 
        first_name: data?.first_name,
        last_name: data?.last_name,
        phone: data?.phone,
        routing_number: data?.routing_number,
        account_number: data?.account_number,
        billing_address1: data?.billing_address1,
        billing_address2: data?.billing_address2,
        is_email_check: true,
      });
      window?.axios?.post(PROFILE_UPDATE_API_URL, jsonData, {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + accessToken,
          }
      }).then(function (result) {
        console.log("result?.data?.data", result?.data?.data?.first_name)
          dispatch(updateUser(result?.data?.data));
      })  
      .catch(function (result) {
          if(result?.response?.status === 403) {
              dispatch(CallLogoutUser());
              localStorage.removeItem("access_tokens");
          };
      });
    }else{
      dispatch(getUser(result?.data?.data));
    }
  }

  // input field space issue 
  document.getElementById("input")?.addEventListener('keydown', function (e) {
      if (this.value.length === 0 && e.which === 32) e.preventDefault();
  });

  const signUpSidbarClose = () => {
    setTimeout(() => {
      setSignUp(false); 
      setFromBankendSignupDetails({});
      document.getElementById("signupflag")?.classList?.remove("active");
      setAllclearData(true);
    }, 200);
  };

  const ResetPasswordWrapper = () => {
      const navigate = useNavigate();
      const locationPassed = sessionStorage.getItem("LocateCheckPassed") === "true";

      useEffect(() => {
          if (!locationPassed) {
              sessionStorage.setItem("PostLocationRedirectUrl", window.location.pathname);
              navigate("/locate-check");
          }
      }, [locationPassed, navigate]);

      return locationPassed ? <ResetPassword /> : null;
  };
  
  return (<div className="wrapper" style={{paddingTop: LocationUrl==="locate-check" ? "0px":""}} >
      <BrowserRouter>
          <LocationRedirect>
              {(LocationGet.split("/")[1] !== "reset-password" && LocationGet.split("/")[1] !== "locate-check") && <Header setSignUp={setSignUp} setLoginSigupUp={setLoginSigupUp} setLocationGet={setLocationGet} />}
              <ScrollToTop />
              <Routes>
                  {/* <Route path="*" element={<Navigate replace to={HOME_URL}/>} /> */}
                  <Route path="/locate-check" element={<LocateCheck />} />
                  <Route path={HOME_URL} element={<Home setLoginSigupUp={setLoginSigupUp} setLocationGet={setLocationGet} />} />
                  <Route path={MY_ACCOUNT} element={(accessToken !== "" && is_login !== "no") ? <Account /> : <Navigate replace to={HOME_URL}/>} />
                  <Route path={PRIVACY_POLICY} element={<Privacy />} />
                  <Route path={RESPONSIBLE_GAME_PLAY} element={<ResponsibleGamePlay />} />
                  <Route path={TERMS_CONDITIONS} element={<TermsConditions />} />
                  <Route path={PROMOTIONAL_RULES} element={<PromotionalRules />} />
                  <Route path={CONTACT} element={<Contact />} />
                  {/* <Route path={`${RESET_PASSWORD}/:roomId`} element={<ResetPassword />} /> */}
                  <Route
                    path={`${RESET_PASSWORD}/:roomId`}
                    element={<ResetPasswordWrapper />}
                  />
                  <Route path={USER_DATA_DETECTION} element={<Userdatadeletion />} />
              </Routes>
              {(LocationGet.split("/")[1] !== "reset-password" && LocationGet.split("/")[1] !== "locate-check") && <Footer />}
              <SignUpSidebar AllclearData={AllclearData} setAllclearData={setAllclearData} VerifiedLoginEmail={VerifiedLoginEmail} setVerifiedLoginEmail={setVerifiedLoginEmail} fromBankendSignupDetails={fromBankendSignupDetails} setFromBankendSignupDetails={setFromBankendSignupDetails} SignUp={SignUp} setSignUp={setSignUp} setLoginSigupUp={setLoginSigupUp} />
              {LoginSigupUp && (<LoginSignupModal setVerifiedLoginEmail={setVerifiedLoginEmail} setFromBankendSignupDetails={setFromBankendSignupDetails} setLoginSigupUp={setLoginSigupUp} setSignUp={setSignUp} />)}
              {SignUp && (<div className='backgroundmodal' onClick={() => signUpSidbarClose()}></div>)}
              <ResponsiveSidebar setSignUp={setSignUp} profiledata={profiledata} accessToken={accessToken} is_login={is_login}/>
          </LocationRedirect>
      </BrowserRouter>
      <ToastContainer />
    </div>);
}

export default App;
